import { setDOBToMember } from '@hc-frontend/business'
import { stringToDate } from '@hc-frontend/utils'

function convertToMember(members: IMember[]): IMember[] {
  return members.map(member => {
    member.type = member.type.toLowerCase() as MemberType
    if (member.dob) {
      member = setDOBToMember(
        member,
        member.dob instanceof Date ? member.dob : stringToDate(member.dob)
      )
    }
    return member
  })
}

export { convertToMember }
